export default {
  MuiFormControlLabel: {
    styleOverrides: {
      label: {
        color: '#546E7A',
      },
    },
  },
}
